import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

enum Texts {
  typeDate = 'Fecha o rango de la operación *',
  date = 'Fecha (si se trata de una operacion especifica )',
  period = 'Periodo',
  operationRef = 'Referencia de la operación',
  from = 'Desde',
  to = 'Hasta',
}

@Component({
  selector: 'description-ras-date',
  templateUrl: './description-ras-date.component.html',
  styleUrls: ['./description-ras-date.component.scss'],
})
export class DescriptionRasDateComponent implements OnInit {
  public Texts = Texts;
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();
  constructor() {}

  ngOnInit() {}

  get typeDate() {
    return this.form.controls.typeDate.value;
  }
  get isDate() {
    return this.typeDate == 'date';
  }
  get isPeriod() {
    return this.typeDate == 'period';
  }

  get date() {
    return this.form.get('date');
  }

  get from() {
    return this.form.get('from');
  }

  // get operationRef() {
  //   return this.form.get('operationRef');
  // }

  get to() {
    return this.form.get('to');
  }
  onTypeDateChange() {
    if (this.isDate) {
      this.date.setValidators([Validators.required]);
      // this.operationRef.setValidators([Validators.required]);
      this.from.clearValidators();
      this.to.clearValidators();
    }
    if (this.isPeriod) {
      this.date.clearValidators();
      // this.operationRef.clearValidators();
      this.from.setValidators([Validators.required]);
      this.to.setValidators([Validators.required]);
    }

    this.date.updateValueAndValidity();
    // this.operationRef.updateValueAndValidity();
    this.to.updateValueAndValidity();
    this.from.updateValueAndValidity();
    this.formChange.emit(this.form);
  }
}
